import { EMAIL_MESSAGE_STATUSES, PaymentMethods } from '../../../../../../services/exports/Constants';
import TemplateNames from '../email-messages/TemplateNames';

export default {
  page_title: 'Follower',
  fields: {
    name: 'Name:',
    email: 'Email:',
    phone_number: 'Telefon:',
    subscribed: 'Abonniert:',
    birthday: 'Geburtstag:',
    location: 'Standort:',
    followed: 'Gefolgt:',
    lifetime_spent: 'Lebenslang € ausgegeben:',
    total_orders: 'Bestellungen Gesamt:',
    google_review: 'Google Bewertung:',
    loyalty_lifetime: 'Treuepunkte gesamt:',
    loyalty_points: 'Treuepunkte heute:',
  },
  labels: {
    yes: 'Ja',
    no: 'Nein',
    followed_since_date: 'Seit {{date}}',
  },
  buttons: {
    edit: 'Bearbeiten',
    request_data_deletion: 'Datenlöschung beantragen',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
  },
  tabs: {
    recent_orders: {
      title: 'Letzte Bestellungen',
      columns: {
        order_id: 'Id',
        items: 'Artikel',
        total: 'Gesamtbetrag',
        paid_on: 'Bezahlt am',
        payment_method: 'Zahlungsmethode',
      },
      labels: {
        no_orders: 'Noch keine Bestellungen',
      },
      payment_methods: {
        [PaymentMethods.CARD]: 'Kreditkarte',
        [PaymentMethods.PAYPAL]: 'PayPal',
        [PaymentMethods.APPLE_PAY]: 'Apple Pay',
        [PaymentMethods.GOOGLE_PAY]: 'Google Pay',
        [PaymentMethods.LINK]: 'Link',
        [PaymentMethods.SOFORT]: 'Sofort',
        [PaymentMethods.IDEAL]: 'iDEAL | Wero',
        [PaymentMethods.BANCONTACT]: 'Bancontact',
        [PaymentMethods.EPS]: 'EPS',
        [PaymentMethods.P24]: 'Przelewy24',
        [PaymentMethods.BLIK]: 'BLIK',
        [PaymentMethods.TWINT]: 'TWINT',
        [PaymentMethods.VENMO]: 'Venmo',
        [PaymentMethods.WERO]: 'Wero',
        [PaymentMethods.KLARNA]: 'Klarna',
        [PaymentMethods.TRUSTLY]: 'Trustly',
        [PaymentMethods.PIX]: 'Pix',
        [PaymentMethods.NUPAY]: 'NuPay',
        [PaymentMethods.GIROPAY]: 'Giropay',
        [PaymentMethods.SEPA_DEBIT]: 'Bank debit',
        [PaymentMethods.CASH]: 'Bargeld',
        [PaymentMethods.BACS_DEBIT]: 'Bank debit',
      },
    },
    messages: {
      title: 'Nachrichten',
      columns: {
        template: 'Vorlage',
        status: 'Status',
        opened: 'Geöffnet',
        clicked: 'Geklickt',
        spam_complaint: 'Spam Beschwerde',
        unsubscribed: 'Abgemeldet',
        sent_at: 'Gesendet am',
      },
      labels: {
        yes: 'Ja',
        no: 'Nein',
        not_detected: 'Nicht erkannt',
        opened_at: 'Geöffnet am {{date}}',
        clicked_at: 'Geklickt am {{date}}',
        complained_at: 'Beschwert am {{date}}',
        unsubscribed_at: 'Abgemeldet am {{date}}',
        no_messages: 'Noch keine Nachrichten',
      },
      message_statuses: {
        [EMAIL_MESSAGE_STATUSES.SENT]: 'Gesendet',
        [EMAIL_MESSAGE_STATUSES.DELIVERED]: 'Zugestellt',
        [EMAIL_MESSAGE_STATUSES.FAILED]: 'Fehlgeschlagen',
      },
      template_names: {
        ...TemplateNames,
      },
      toasts: {
        failed_to_load_data: 'Daten konnten nicht geladen werden',
      },
    },
    balance_history: {
      title: 'Dein Punktverlauf',
      columns: {
        created_at: 'Datum',
        source: 'Quelle',
        value: 'Punkte',
        points_expire_at: 'Gültig bis',
      },
      labels: {
        source: {
          welcome_bonus: 'Willkommensbonus',
          google_review_reward: 'Belohnung für Google-Bewertung',
          reward_loyalty_program_conversion: 'Belohnung für Treueprogramm-Umwandlung',
          cashback: 'Cashback',
          refund: 'Rückerstattung',
          cashback_usage: 'Cashback-Nutzung',
          cashback_usage_refund: 'Rückerstattung der Cashback-Nutzung',
          expired_points_void: 'Verfallene Punkte',
          mobile_app_signup_bonus: 'Bonus für App-Registrierung',
        },
        no_operations: 'Noch keine Aktivitäten',
      },
    },
  },
};
